import { Ban, Eye, Flame } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const STATS = [
  { icon: Eye, label: "DOUBLE-TAKES", value: "100%" },
  { icon: Flame, label: "CHEEK LEVEL", value: "MAXIMUM" },
  { icon: Ban, label: "PANTS", value: "NOT FOUND" },
];

const LORE_LINES = [
  "$ cat lore.txt",
  "> subject: pepe",
  "> cheeks: 2 (two)",
  "> pants: not found",
  "> shame: 0",
];

export default function About() {
  return (
    <section id="lore" data-testid="about-section" className="relative py-28 sm:py-36">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-5 sm:px-8 lg:grid-cols-2">
        <Reveal className="relative order-2 lg:order-1">
          <div
            aria-hidden="true"
            className="absolute -inset-6 bg-[radial-gradient(closest-side,rgba(255,0,255,0.1),transparent)]"
          />
          <div className="relative border border-neon/40 bg-surface shadow-[inset_0_0_40px_rgba(57,255,20,0.04)]">
            <div className="flex items-center gap-2 border-b border-line px-5 py-3">
              <span className="h-2.5 w-2.5 rounded-full bg-blood/80" />
              <span className="h-2.5 w-2.5 rounded-full bg-punk/70" />
              <span className="h-2.5 w-2.5 rounded-full bg-neon/80" />
              <span className="ml-3 font-mono text-[11px] tracking-[0.2em] text-[#6b7f6b] uppercase">
                pepebutt@solana: ~/lore
              </span>
            </div>
            <div className="px-5 py-6 font-vt text-lg leading-loose sm:px-8 sm:text-xl">
              {LORE_LINES.map((line, i) => (
                <Reveal key={line} delay={0.1 + i * 0.1}>
                  <p className={i === 0 ? "text-[#6b7f6b]" : "text-[#9fb39f]"}>
                    {line}
                  </p>
                </Reveal>
              ))}
              <p className="text-neon">
                {">"} verdict: THE MEME IS THE BUTT
                <span className="animate-blink ml-1">█</span>
              </p>
            </div>
          </div>
          <p className="mt-4 font-mono text-[11px] tracking-[0.2em] text-[#6b7f6b] uppercase">
            EXHIBIT A — THE TURNAROUND, CIRCA FOREVER
          </p>
        </Reveal>

        <div className="order-1 lg:order-2">
          <SectionHeading index="01" eyebrow="THE LORE" title="HE TURNED AROUND. THE TIMELINE GASPED." testId="about-heading" />
          <Reveal delay={0.15}>
            <p className="mt-8 max-w-lg text-sm leading-relaxed text-[#9fb39f] sm:text-base">
              Nobody asked him to. Nobody could stop him. One quiet morning,
              Pepe simply turned around — and the timeline has never
              recovered. <span className="text-neon">$PEPEBUTT</span> is that
              moment, immortalized on Solana.
            </p>
            <p className="mt-5 max-w-lg text-sm leading-relaxed text-[#9fb39f] sm:text-base">
              No promises. No utility. No pants. Just a frog with
              generational cheeks and a community of degenerates who
              understand one truth:{" "}
              <span className="text-punk">the butt is the meme.</span>
            </p>
          </Reveal>

          <div className="mt-12 grid grid-cols-1 gap-px border border-line bg-line sm:grid-cols-3">
            {STATS.map((s, i) => (
              <Reveal key={s.label} delay={0.1 + i * 0.1} className="bg-nox p-5">
                <s.icon size={16} className="text-neon" />
                <p className="mt-3 font-vt text-2xl text-[#EDEDE4]">{s.value}</p>
                <p className="mt-1 font-mono text-[10px] tracking-[0.2em] text-[#6b7f6b] uppercase">
                  {s.label}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
